import styled from 'styled-components'

export const StyledTextarea = styled.textarea`
  background: ${({ theme }) => theme.themeColorWhite};
  border-radius: ${({ theme }) => theme.borderRadius};
  border: 0;
  box-shadow: 1px 1px 2px 0 rgba(0,0,0,.1);
  color: ${({ theme }) => theme.themeColorPrimary};
  padding: ${({ theme }) => theme.gutterSmall} ${({ theme }) => theme.gutter};
  padding-right: calc(${({ theme }) => theme.gutter} * 2);
  font-size: 1em;
  line-height: ${({ theme }) => theme.lineHeightRegular};
  width: 100%;
  font-family: ${({ theme }) => theme.fontFamilyPrimary};

  &::placeholder {
    color: ${({ theme }) => theme.themeColorPale};
    opacity: 1;
  }
  
  &:focus {
    box-shadow: 2px 2px 4px 0 rgba(0,0,0,.2);
  }

  ${(props) => (props.type === 'date' || props.type === 'time') && `
    min-height: 2em;
  `}


  .under-validation &:invalid {
    border: 2px solid ${({ theme }) => theme.themeColorError};
    box-shadow: none;
  }

  .under-validation &[required]:valid {
    border: 2px solid ${({ theme }) => theme.themeColorAccent};
    box-shadow: none;
  }
`

export const Container = styled.article`
  width: 100%;
  position: relative;

  ${({ half, theme }) => half && `
    width: calc(50% - ${theme.gutter});
  `}

  ${({ third, theme }) => third && `
    width: calc(33.33% - ${theme.gutter});
  `}
  
`